export default "__VITE_ASSET__DfHX4Plc__"